import React from 'react';
interface ProgressBarProps {
  current: number;
  total: number;
  label?: string;
}
export const ProgressBar = ({
  current,
  total,
  label
}: ProgressBarProps) => {
  const percentage = Math.max(0, Math.min(100, current / total * 100));
  return <div className="w-full max-w-[680px] mx-auto" data-id="element-13">
      <div className="bg-border h-2 rounded-full overflow-hidden mb-1.5" data-id="element-14">
        <div className="h-full rounded-full transition-all duration-500 ease-out bg-gradient-to-r from-primary to-gold" style={{
        width: `${percentage}%`
      }} data-id="element-15" />
      </div>
      {label && <div className="text-[12px] text-textlight text-center" data-id="element-16">{label}</div>}
    </div>;
};